
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 8 8\" id=\"icon-size\" > <title>size</title> <path d=\"M6.27,3,3,6.27,4.78,8H0V3.22L1.73,5,5,1.73,3.22,0H8V4.78Z\"/> </symbol>";
module.exports = sprite.add(image, "icon-size");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/size.svg
 ** module id = 219
 ** module chunks = 24
 **/